import { combineReducers } from 'redux';

import fetchContentReducer from './content/reducer';
import setFiltersReducer from './filters/reducer';
import overlayReducer from './ui/overlay/reducer';
import logoReducer from './ui/logo/reducer';

import reducerEvents from './contentEvents/reducer';

export default combineReducers({
  content: fetchContentReducer,
  filters: setFiltersReducer,
  overlay: overlayReducer,
  pageContent: reducerEvents,
  logo: logoReducer
})



// WEBPACK FOOTER //
// ./src/services/root-reducer.js